/* import Moment from "moment";
import 'moment/locale/es'; */
import axios from "axios"
import {getHours, getMonth, getDate, getDay} from 'date-fns'
let week = [6,0,1,2,3,4,5]
export default class TagFunctions {
  static evAuthenticationPush = async (platform) => {
    let country;
    try {
      let res = await axios.get("https://extreme-ip-lookup.com/json/?key=LSrYRa4bab9N0BLiYnzF")
      country = res.data.country
    } catch (e) {
      country = undefined;
    }
    //const userAgent = navigator.userAgent;

    let digData = {
      event: "authentication",
      userData: {
        userId: sessionStorage.getItem('userId') || undefined,
        userInfo: {
          age: Number(sessionStorage.getItem('ageUser'))?Number(sessionStorage.getItem('ageUser')):undefined,
          birthYear: Number(sessionStorage.getItem('ageUserBirthYear'))?Number(sessionStorage.getItem('ageUserBirthYear')):undefined,
          country: country?country:undefined
        },
        profile: {
          loginType: sessionStorage.getItem('network')?sessionStorage.getItem('network'):'Normal',
          //platform: userAgent,
          platform: 'web',
        }
      },
    };
    window.dataLayer.push(digData);
  };

  static evPageViewPush = async (pageName) => {
    let country;
    try {
      let res = await axios.get("https://extreme-ip-lookup.com/json/") //this request can be block by some adblockers
      country = res.data.country
    } catch (e) {
      country = "NA";
      //console.log(`Can't connect to backend try latter`);
    }
    
    let lang = window.navigator.language.toLowerCase().startsWith('es') ? 'ESP' : 'ENG'
    //Moment.locale('es')
    //const today = Moment();
    const today = new Date()
    var loc = window.location;

    let digitalData = {
      event: "evPageView",
      version: "1.0",
      page: {
        pageInfo: {
          hostName: `${loc.origin}`,
          pageName: `${pageName}`,
          currentURL: `${loc.href}`
        }
      },
      user: {
        profile: {
          userWeekDay: `${week[getDay(today)]}`,
          userMonthDay: `${getDate(today)}`,
          userMonth: `${getMonth(today)}`,
          userTime: `${getHours(today)}`,
          languajeUser: lang,
          profileInfo: {
            //ageUserBirthYear: sessionStorage.getItem('ageUserBirthYear')?sessionStorage.getItem('ageUserBirthYear'):'NA',
            ageUserBirthYear: Number(sessionStorage.getItem('ageUserBirthYear'))?Number(sessionStorage.getItem('ageUserBirthYear')):'NA',
            //ageUser: sessionStorage.getItem('ageUser')?sessionStorage.getItem('ageUser'):'NA',
            ageUser: Number(sessionStorage.getItem('ageUser'))?Number(sessionStorage.getItem('ageUser')):'NA',
            ageUserCountry: country?country:'NA',
            email: sessionStorage.getItem('userId') || 'NA'
          },
          social: {
            network: sessionStorage.getItem('network')?sessionStorage.getItem('network'):'Normal'
          }
        }
      }
    };
    window.dataLayer.push(digitalData);
  };

  static evAgeGatePush = (action, error = 'NA') => {
      window.dataLayer.push({
        action: `${action}`,
        error: `${error}`,
        event: "evAgeGate"
      });
  };

  static evClickOptionsPush = action => {
    window.dataLayer.push({
      actionClick: `${action}`,
      event: "evClickOptions"
    });
  };

  static evSocialNetworkPush = (socialNetwork, action) => {
    window.dataLayer.push({
      socialNetworkName: `${socialNetwork}`,
      actionSocialNetwork: `${action}`,
      event: "evSocialNetwork"
    });
  };

  static evib2cOutboundlinkPush = name => {
    window.dataLayer.push({
      nameOutboundLinkib2C: `${name}`,
      event: "evib2cOutboundlink"
    });
  };

  static evVideoPush = (name, action, quartile) => {
    window.dataLayer.push({
      videoName: `${name}`,
      videoAction: `${action}`,
      videoQuartile: `${quartile}`,
      event: "evVideo"
    });
  };

  // Events GA4
  static user_interactionPush = (action, element, section) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "user_interaction",
      eventParams: {
        action: `${action}`,
        element: `${element}`,
        section: `${section}`
      }
    });
  };

  static form_interactionPush = (name, action) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "form_interaction",
      eventParams: {
        form_name: "age gate",
        form_field: `${name}`,
        form_action: `${action}`,
        section: "login"
      }
    });
  };

  static form_sendPush = (name, element) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "form_send",
      eventParams: {
        form_name: "age gate",
        form_field: `${name}`,
        element: `${element}`,
        section: "login"
      }
    });
  };

  static methodPush = (method) => {
    window.dataLayer.push({
      event: "ga4.trackEvent",
      eventName: "login",
      eventParams: {
        method: `${method}`
      }
    });
  };
}
